import { colors } from 'Constants/Colors';
import styled from '@emotion/styled';

const Span = styled.span`
  font-size: 34px;
  font-weight: bold;
`;

const EmployeeSpan = styled(Span)`
  color: ${colors.GREEN};
`;

interface TitleProps {
  title: string;
  employee: string;
}

const Title = ({ title, employee }: TitleProps) => {
  return (
    <Span>
      {title} <EmployeeSpan>{`"${employee}"`}</EmployeeSpan>
    </Span>
  );
};

export default Title;
